import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail, setStoredToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ChangePasswordDialog = ({ open, onClose, forced = false }) => {
  const { user, setUser } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (pw.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (pw !== pw2) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      if (data?.access_token) setStoredToken(data.access_token);
      toast.success("Password aggiornata");
      setUser({ ...user, must_change_password: false });
      setCur(""); setPw(""); setPw2("");
      onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !forced) onClose(); }}>
      <DialogContent className="bg-white border-slate-200 text-slate-800 max-w-md" data-testid="change-password-dialog"
                     onInteractOutside={(e) => forced && e.preventDefault()} onEscapeKeyDown={(e) => forced && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#1E4FD8]" /> {forced ? "Imposta la tua password" : "Cambia password"}</DialogTitle>
          <DialogDescription>{forced ? "Stai usando una password temporanea: scegline una personale per continuare." : "Inserisci la password attuale e quella nuova (minimo 8 caratteri)."}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label>{forced ? "Password temporanea ricevuta via email" : "Password attuale"}</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="bg-white border-slate-200" data-testid="change-password-current" /></div>
          <div className="space-y-1.5"><Label>Nuova password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="bg-white border-slate-200" data-testid="change-password-new" /></div>
          <div className="space-y-1.5"><Label>Ripeti nuova password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="bg-white border-slate-200" data-testid="change-password-confirm" onKeyDown={(e) => e.key === "Enter" && save()} /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          {!forced && <Button variant="outline" className="border-slate-200" onClick={onClose}>Annulla</Button>}
          <Button onClick={save} disabled={busy || !cur || !pw || !pw2} className="bg-[#1E4FD8] hover:bg-[#173FB0] text-white" data-testid="change-password-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva password"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
